import { useState } from 'react'

import internalApiQueryWrapper from '../../core/internalApiQueryWrapper'
import { validateEmail } from './utils/validateEmail'

const configureParams = ({ newsletterList, email }) => {
  const lists = newsletterList.filter(list => list.checked).reduce((acc, list) => ({ ...acc, [list.name]: 1 }), {})
  return {
    email,
    lists: JSON.stringify(lists)
  }
}

const SignUp = ({ email, newsletterList, setHelperText }) => {
  const [subscriptionMessage, setSubcriptionMessage] = useState('')
  const [messageClassName, setMessageClassName] = useState('')

  const signUp = () => {
    if (validateEmail(email)) {
      internalApiQueryWrapper('/api/newsletter/subscribe', configureParams({ newsletterList, email })).then(
        ({ ok }) => {
          if (ok) {
            setSubcriptionMessage('All set, thanks for signing up!')
            setMessageClassName('subscriptionMessage')
          } else {
            setSubcriptionMessage('Oops, something went wrong')
            setMessageClassName('subscriptionMessage error')
          }
        }
      )
    } else {
      setHelperText('Oops, that email address is invalid!')
    }
  }

  return (
    <div className='signup-container'>
      <button className='signup-button' onClick={signUp}>
        <span className='signup-button-text'>Sign up</span>
      </button>
      {subscriptionMessage && <div className={messageClassName}>{subscriptionMessage}</div>}
    </div>
  )
}

export default SignUp
